<template>
    <vue-final-modal
        v-model="show"
        name="welcome-modal"
        classes="vizion-modal-container"
        content-class="vizion-modal-content"
        :esc-to-close="escToClose"
    >
        <button class="vizion-modal-close" @click="handleClose">
            <i class="fas fa-times"></i>
        </button>

        <span class="vizion-modal-title">
            Vítajte na Vizionshope
        </span>
    </vue-final-modal>
</template>

<script>
import { inject, onMounted, ref } from 'vue'
import { setCookie } from '../../functions/useSetCookie'
import { getCookie } from '../../functions/useGetCookie'

export default {

    setup() {
        const $vfm = inject('$vfm'),
            escToClose = ref(true);

        let show = ref(false);

        onMounted(() => {
            show.value = getCookie('welcomeMessageHidden') === null;
        });

        function handleClose() {
            show.value = false;
            setCookie('welcomeMessageHidden', true, 30);
        }

        return {
            show,
            escToClose,
            handleClose,
            $vfm
        }
    }
}
</script>
